<template>
  <section>
    <article
      v-for="(publication, index) in data"
      :key="index"
      :class="[$style.article, 'space-48-64-above']"
    >
      <router-link
        class="aspect-container focus-outline"
        :to="{
          name: 'PublicationPost',
          params: {
            slug: publication.slug,
          },
        }"
      >
        <picture>
          <img
            :alt="publication.featuredImage.node.altText"
            :src="publication.featuredImage.node.sourceUrl"
            :srcset="publication.imageSrcset"
            class="aspect-image"
            loading="lazy"
            sizes="(min-width: 960px) 470px, 100vw"
          />
        </picture>
      </router-link>
      <div :class="$style.info">
        <header>
          <h2 class="heading-4">
            <router-link
              :to="{
                name: 'PublicationPost',
                params: {
                  slug: publication.slug,
                },
              }"
            >
              {{ publication.title }}
            </router-link>
          </h2>
        </header>
        <PublicationAuthors :data="publication" :is-archive="true"></PublicationAuthors>
      </div>
    </article>
    <GuggenPagination
      :current-page="page"
      :per-page="limit"
      :sub-type="subType"
      :sub-type-value="subTypeValue"
      :total-page-count="totalPageCount"
      post-type="publication"
    ></GuggenPagination>
  </section>
</template>

<script setup lang="ts">
import GuggenPagination from '@/components/GuggenPagination.vue';
import { Publication } from '@/types/publication.interface';
import PublicationAuthors from '@/components/publication/PublicationAuthors.vue';

defineProps<{
  data: Array<Publication>;
  page?: number;
  subType?: string;
  subTypeValue?: string;
  totalPageCount?: number;
}>();

const limit = 8;
</script>

<style lang="scss" module>
.article {
  display: block;

  &:first-of-type {
    margin-top: 1rem;
  }

  > a {
    background-color: $white;
  }
}
.info {
  margin-top: 1rem;

  a {
    &:focus,
    &:hover {
      text-decoration: underline;
    }
  }
  h2 {
    margin-top: 0;

    a {
      text-decoration: none;

      &:focus {
        color: $white;
        text-decoration: none;
      }
    }
  }
}

@media (min-width: $break-point) {
  .article {
    @include grid;
    grid-column: 1 / span 8;
    grid-template-columns: repeat(8, 1fr);

    a {
      grid-column: span 4;
    }
  }
  .info {
    grid-column: span 4;
    margin-top: 0;
  }
}
</style>
